var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
var StyledLayout = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 500px;\n  max-width: calc(100% - ", "px);\n  margin: 0 auto;\n  padding: 30vh 0 50px;\n  text-align: center;\n"], ["\n  width: 500px;\n  max-width: calc(100% - ", "px);\n  margin: 0 auto;\n  padding: 30vh 0 50px;\n  text-align: center;\n"])), function (props) { return props.theme.spacing * 4; });
export default (function (props) {
    return _jsx(StyledLayout, { children: props.children });
});
var templateObject_1;
//# sourceMappingURL=index.js.map